// extracted by mini-css-extract-plugin
export var imageWrapper = "Rollerblinds-module--imageWrapper--1T_km";